import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const getAdminToken = () => localStorage.getItem('admin_token');

export const getAdminRole = () => localStorage.getItem('admin_role');

export const setAdminSession = ({ token, role }) => {
  localStorage.setItem('admin_token', token);
  if (role) localStorage.setItem('admin_role', role);
};

export const clearAdminSession = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_role');
};

export const fetchMe = async () => {
  const token = getAdminToken();
  if (!token) return null;

  const res = await axios.get(`${API}/admin/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
